/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Faq_A1Inputs */

const es_marketplace_seo_spain_faq_a1 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El precio depende del tipo de embarcación, la temporada y si incluye patrón o combustible. Hay opciones desde unos 100 € al día en barcos pequeños hasta varios cientos en veleros o yates con capitán. Cada anuncio muestra el precio base y los extras.`)
};

const gl_marketplace_seo_spain_faq_a1 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O prezo depende do tipo de embarcación, a tempada e se inclúe patrón ou combustible. Hai opcións dende uns 100 € ao día en barcos pequenos ata varios centos en veleiros ou iates con capitán. Cada anuncio mostra o prezo base e os extras.`)
};

const en_marketplace_seo_spain_faq_a1 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price depends on boat type, season and whether a skipper or fuel is included. Options start around €100 per day for small boats up to several hundred for sailboats or yachts with captain. Each listing shows base price and extras.`)
};

/**
* | output |
* | --- |
* | "Price depends on boat type, season and whether a skipper or fuel is included. Options start around €100 per day for small boats up to several hundred for sai..." |
*
* @param {Marketplace_Seo_Spain_Faq_A1Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_faq_a1 = /** @type {((inputs?: Marketplace_Seo_Spain_Faq_A1Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Faq_A1Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_faq_a1(inputs)
	if (locale === "en") return en_marketplace_seo_spain_faq_a1(inputs)
	return es_marketplace_seo_spain_faq_a1(inputs)
});